"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TitledBox;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _excluded = ["actions", "children", "id", "title", "titleKey"];
function TitledBox(_ref) {
  var actions = _ref.actions,
    children = _ref.children,
    id = _ref.id,
    title = _ref.title,
    titleKey = _ref.titleKey,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_material.Box, (0, _extends2.default)({
    bgcolor: "background.default",
    id: id,
    padding: 2
  }, rest), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    alignItems: "center",
    container: true,
    spacing: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    gutterBottom: true,
    id: "".concat(id, "Title"),
    variant: "h6"
  }, title || /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: titleKey || 'item.loading'
  }))), actions && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    id: "".concat(id, "Actions"),
    item: true
  }, actions)), children);
}